import { render, staticRenderFns } from "./family.vue?vue&type=template&id=71b312fe"
import script from "./family.vue?vue&type=script&lang=js"
export * from "./family.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports